import { SITUACAO_BADGE_FALLBACK, SITUACAO_BADGE_STYLES, SITUACAO_LABELS } from "@/lib/labels";
import { cn } from "@/lib/utils";
import { Badge } from "./ui/badge";

interface SituacaoBadgeProps {
  codigo: number;
  /** Rótulo vindo dos lookups da API; cai no mapa local quando ausente. */
  label?: string;
  className?: string;
}

/** Badge colorida da situação cadastral (verde/vermelho/amarelo/laranja/cinza). */
export function SituacaoBadge({ codigo, label, className }: SituacaoBadgeProps) {
  const text = label ?? SITUACAO_LABELS[codigo] ?? `Situação ${codigo}`;
  const style = SITUACAO_BADGE_STYLES[codigo] ?? SITUACAO_BADGE_FALLBACK;
  return <Badge className={cn(style, className)}>{text}</Badge>;
}
